import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import parse from 'html-react-parser';

class DemoDetail extends Component {

    render() {

        return (
            <div>
                <section className="demo-section">
                    <div className="container">

                        <div className="row justify-content-center mb-5">
                            <div className="col-lg-8 text-center">
                            <span className="demo-badge">
                                LIVE DEMOS
                            </span>

                                <h2 className="demo-title mt-3">
                                    Explore Our Live Solutions
                                </h2>

                                <p className="demo-subtitle">
                                    Experience our production-ready platforms built for
                                    Real Estate, Ecommerce and Education.
                                </p>
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-lg-4 mb-4">
                                <a
                                    href="https://smartpropertieshub.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="demo-box"
                                >
                                    <div className="demo-circle">
                                        🏠
                                    </div>

                                    <h4>Property Management</h4>

                                    <p>
                                        Smart property listings, management and customer
                                        experience platform.
                                    </p>

                                    <div className="visit-link">
                                        Visit Demo
                                        <span>→</span>
                                    </div>
                                </a>
                            </div>

                            <div className="col-lg-4 mb-4">
                                <a
                                    href="https://scentesiafragrance.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="demo-box"
                                >
                                    <div className="demo-circle">
                                        🛍️
                                    </div>

                                    <h4>Ecommerce Store</h4>

                                    <p>
                                        Modern ecommerce experience designed for premium
                                        brands.
                                    </p>

                                    <div className="visit-link">
                                        Visit Demo
                                        <span>→</span>
                                    </div>
                                </a>
                            </div>

                            <div className="col-lg-4 mb-4">
                                <a
                                    href="https://converzex.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="demo-box"
                                >
                                    <div className="demo-circle">
                                        🎓
                                    </div>

                                    <h4>Education Platform</h4>

                                    <p>
                                        Interactive education platform for learning and
                                        communication.
                                    </p>

                                    <div className="visit-link">
                                        Visit Demo
                                        <span>→</span>
                                    </div>
                                </a>
                            </div>

                        </div>

                    </div>
                </section>
            </div>
        );

    }
}

export default DemoDetail